var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 741.08 381.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f7931e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M175.19,156.21a26.59,26.59,0,0,0-2.19-16c-11.56-23.22-59.09-23-106.16.38S-9,201.83,2.55,225.05C9.82,239.65,31.31,245,58,241.14c-8.67,24.6-8.56,45.8,2.23,55.22,12,10.52,34.23,3.57,56.73-15.42,4.45,11.34,10.78,19,18.46,20.83,19.05,4.64,39.16-27.72,44.93-72.27,2.9-22.44,1.61-43.69-2.81-59.86A40.63,40.63,0,0,0,175.19,156.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M570.86,162.46a26.55,26.55,0,0,1,3.45-15.8c13.35-22.24,60.71-18.33,105.79,8.73s70.8,67,57.45,89.27c-8.39,14-30.23,17.63-56.49,11.68,6.71,25.21,4.93,46.34-6.57,54.88-12.83,9.54-34.41.87-55.34-19.84-5.33,11-12.24,18.06-20,19.32-19.34,3.13-36.85-30.71-39.1-75.58-1.14-22.6,1.82-43.68,7.5-59.45A40.81,40.81,0,0,1,570.86,162.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M288.94,90.65a26.57,26.57,0,0,0-1.15-16.13c-10-23.93-57.47-26.83-106-6.5s-79.66,56.21-69.63,80.14c6.31,15,27.41,21.77,54.25,19.64-10.25,24-11.51,45.15-1.36,55.25,11.34,11.28,33.93,5.78,57.62-11.71,3.7,11.6,9.52,19.62,17.07,22,18.7,5.87,40.87-25.12,49.52-69.21,4.35-22.2,4.44-43.49,1.07-59.91A40.49,40.49,0,0,0,288.94,90.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M567.12,112.22a19.62,19.62,0,0,0-10.18-6.33c-18.74-4.39-41.12,22.84-50,60.81S506,239,524.76,243.38c11.78,2.75,25-7,35.4-24,10,16.58,22.11,26.55,32.59,24.85,11.71-1.9,18.24-17.86,18-39.7,8.58,2.83,15.92,2.82,20.63-.69,11.66-8.68,2.69-35.47-20-59.84-11.44-12.28-24.19-21.6-35.51-26.72A29.83,29.83,0,0,0,567.12,112.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M345.56,25.36a26.63,26.63,0,0,0-13.9-8.26c-25.38-5.4-54.82,31.91-65.77,83.34s.75,97.49,26.12,102.89c15.95,3.4,33.51-10.09,47.07-33.35,13.86,22.09,30.53,35.2,44.61,32.62,15.73-2.88,24.11-24.57,23.24-54,11.64,3.58,21.55,3.37,27.8-1.48,15.48-12,2.67-47.9-28.62-80.15-15.75-16.24-33.19-28.45-48.6-35A40.49,40.49,0,0,0,345.56,25.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M535.31,62.27a26.48,26.48,0,0,0-5-15.36C514.71,26.15,468,34.9,425.93,66.44s-63.55,73.94-48,94.7c9.79,13.05,31.88,14.43,57.4,5.82-4.09,25.76-.15,46.6,12.16,53.91,13.74,8.17,34.31-2.66,53-25.4,6.41,10.35,14,16.7,21.92,17.16,19.56,1.12,33.51-34.34,31.14-79.2-1.19-22.6-6.3-43.26-13.57-58.36A40.11,40.11,0,0,0,535.31,62.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.81,126.11S178.68.8,351.54,0C526.1-.79,595.1,65.53,643.1,138.37Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 116.6,
    cy: 328.71,
    rx: 35.5,
    ry: 52.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 624.6,
    cy: 326.71,
    rx: 35.5,
    ry: 52.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset4);
export default __webpack_public_path__ + "static/media/Asset 4.7a4d0406.svg";
export { ForwardRef as ReactComponent };